import { createSelector } from 'reselect';

const selectSlice = state => state.loanRequests;

const emptyArray = Object.freeze([]);

export const selectLoanRequestGroups = createSelector(
  selectSlice,
  slice => slice?.items ?? emptyArray,
);

export const selectLoanRequestsTotalCount = createSelector(
  selectSlice,
  slice => slice?.totalCount ?? 0,
);

export const selectLoanRequestsIsLoading = createSelector(
  selectSlice,
  slice => slice?.isLoading ?? false,
);
